import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const HERO_VIDEO_SRC = "/videos/landing-hero.mp4";

export function LandingHeroVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = useState(true);
  const [videoFailed, setVideoFailed] = useState(false);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    void v.play().catch(() => setVideoFailed(true));
  }, []);

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    const next = !muted;
    v.muted = next;
    setMuted(next);
    if (!next) void v.play().catch(() => {});
  };

  return (
    <div
      className="absolute inset-0 overflow-hidden"
      aria-hidden
      style={
        videoFailed
          ? { background: "linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)" }
          : undefined
      }
    >
      {!videoFailed && (
        <video
          ref={videoRef}
          className="absolute inset-0 h-full w-full object-cover scale-105"
          autoPlay
          loop
          muted
          playsInline
          onError={() => setVideoFailed(true)}
        >
          <source src={HERO_VIDEO_SRC} type="video/mp4" />
        </video>
      )}
      <div className="absolute inset-0 bg-black/15" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-black/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/40" />

      <button
        type="button"
        onClick={toggleSound}
        className="absolute top-24 right-4 md:right-8 z-20 flex flex-col items-center gap-1 text-white/60 hover:text-white transition-colors"
        aria-label={muted ? "Unmute background video" : "Mute background video"}
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/25 bg-black/40 backdrop-blur-sm">
          {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
        </span>
        <span className="text-[10px] font-sans uppercase tracking-wider">
          {muted ? "Sound off" : "Sound on"}
        </span>
      </button>
    </div>
  );
}
